import { useForm } from "react-hook-form";

export function useValidatedInputForm() {
  return useForm({ mode: "all", delayError: 1000 });
}
